import { BadgeCheck } from 'lucide-react';

interface PriceDisplayProps {
  isFree?: boolean;
  originalPrice?: string;
  variant?: 'compact' | 'detail';
  className?: string;
}

export const PriceDisplay = ({
  isFree = false,
  originalPrice,
  variant = 'compact',
  className = '',
}: PriceDisplayProps) => {
  const normalizedPrice = originalPrice?.trim();
  const isDetail = variant === 'detail';

  if (!isFree && !normalizedPrice) {
    return null;
  }

  return (
    <span
      className={`inline-flex flex-wrap items-center ${isDetail ? 'gap-3' : 'gap-1.5'} ${className}`.trim()}
      aria-label={isFree ? `Free${normalizedPrice ? `, originally ${normalizedPrice}` : ''}` : normalizedPrice}
    >
      {isFree ? (
        <span
          className={`inline-flex items-center bg-gradient-to-b from-emerald-50 to-emerald-100/80 font-bold text-emerald-800 shadow-[inset_0_1px_0_rgba(255,255,255,0.9),0_1px_2px_rgba(5,150,105,0.08)] ${
            isDetail
              ? 'gap-2 rounded-xl border border-emerald-200 px-3.5 py-2 text-base'
              : 'gap-0.5 rounded px-1.5 py-0.5 text-[0.6rem]'
          }`}
        >
          <BadgeCheck className={isDetail ? 'h-5 w-5' : 'h-3 w-3'} strokeWidth={2.25} aria-hidden="true" />
          <span>Free</span>
        </span>
      ) : null}
      {normalizedPrice ? (
        <span
          className={
            isFree
              ? `${isDetail ? 'text-base' : 'text-[0.66rem]'} font-medium text-slate-500 line-through decoration-[1.5px] decoration-slate-400`
              : `${isDetail ? 'text-3xl' : 'text-[0.7rem]'} font-bold text-slate-900`
          }
        >
          {normalizedPrice}
        </span>
      ) : null}
    </span>
  );
};
